export default "__VITE_ASSET__C0Q4io1n__"